// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__ItWVv","title":"styles_title__yN50W"};